import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { ButtonsContainer, Button, ButtonWithLoader } from 'virtues-bootstrap';
import { getUniqId } from 'utilities';
import { is, path, propOr } from 'ramda';

import { ReactComponent as IconFileSolid } from 'svg/file-solid.svg';
import { ReactComponent as IconFolderSolid } from 'svg/folder-solid.svg';

import { requestPatientReports } from 'services/api/request/exports';
import { requestPatientGroupUpdate } from 'services/api/request/patient';
import useExport from 'hook/useExport';
import useSimpleRequest from 'hook/useSimpleRequest';
import cx from 'classnames';

import s from './styles.module.scss';

const PatientListToolbar = ({
  isAblilityAddPatient,
  isAblilityUpdatePatientsSiteInformation,
  notificationsAdd,
  region,
  t,
}) => {
  const [setLoadingExport] = useExport(requestPatientReports);
  const [isFetching, startFetching] = useSimpleRequest({
    request: requestPatientGroupUpdate,
    params: { siteId: region },
    callbackOnSuccess: () =>
      notificationsAdd({
        id: getUniqId(),
        variant: 'success',
        title: t('common:feedback.requestTitle'),
        description: t('patient.importPatientInformationSuccess'),
      }),
    callbackOnFailure: err => {
      const errorData = path(['response', 'data'])(err);
      const message = propOr(path(['issue', '0', 'diagnostics'])(errorData), 'message')(errorData);
      notificationsAdd({
        id: getUniqId(),
        variant: 'danger',
        title: t('common:feedback.error'),
        description: is(Object, message) ? JSON.stringify(message) : message,
      });
    },
  });

  return (
    <ButtonsContainer className={cx({ [s.buttonsContainer]: isAblilityAddPatient })} noSpaceTop>
      {isAblilityAddPatient && (
        <Button component={Link} to="/add-patient" variant="secondary">
          {t('addPatient.newPatient')}
        </Button>
      )}

      <div>
        {isAblilityUpdatePatientsSiteInformation && (
          <ButtonWithLoader
            className={s.colorizedLoading}
            icon={<IconFolderSolid />}
            variant="primary"
            outlined
            loading={isFetching}
            onClick={startFetching}
          >
            {t('patient.importPatientInformation')}
          </ButtonWithLoader>
        )}
        <Button
          icon={<IconFileSolid />}
          onClick={() => setLoadingExport(true)}
          variant="primary"
          outlined
        >
          {t('patient.exportData')}
        </Button>
      </div>
    </ButtonsContainer>
  );
};

PatientListToolbar.propTypes = {
  isAblilityAddPatient: PropTypes.bool.isRequired,
  isAblilityUpdatePatientsSiteInformation: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  notificationsAdd: PropTypes.func.isRequired,
  region: PropTypes.string.isRequired,
};

export default withTranslation()(PatientListToolbar);
